import React, { useState, useEffect } from "react";
import { Smartphone, RotateCcw } from "lucide-react";

const MobileBlocker = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isPortraitTablet, setIsPortraitTablet] = useState(false);

  useEffect(() => {
    const checkView = () => {
      // Small screen devices (Phones) in any orientation
      // or strictly narrow widths
      const isPhoneView =
        window.matchMedia("(max-width: 767px)").matches ||
        window.matchMedia(
          "(max-height: 767px) and (max-width: 1000px) and (orientation: landscape)",
        ).matches; // catching large phones like iPhone 15 Pro Max in landscape

      // Tablets in portrait
      const isTabletPortraitView = window.matchMedia(
        "(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)",
      ).matches;

      setIsMobile(isPhoneView);
      setIsPortraitTablet(!isPhoneView && isTabletPortraitView);
    };

    checkView();
    // Use resize and orientationchange events for immediate snap coverage
    window.addEventListener("resize", checkView);
    window.addEventListener("orientationchange", checkView);

    return () => {
      window.removeEventListener("resize", checkView);
      window.removeEventListener("orientationchange", checkView);
    };
  }, []);

  if (!isMobile && !isPortraitTablet) return null;

  return (
    <div className="fixed inset-0 z-[99999] bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-950 flex flex-col items-center justify-center p-8 text-center text-white backdrop-blur-md">
      <div className="bg-white/10 p-8 rounded-3xl border border-white/20 shadow-2xl max-w-lg flex flex-col items-center">
        {isMobile ? (
          <>
            <div className="bg-red-500/20 p-4 rounded-full mb-6 relative">
              <Smartphone className="w-16 h-16 text-red-400" />
              <div className="absolute inset-0 border-2 border-red-400 rounded-full animate-ping opacity-75"></div>
            </div>
            <h2 className="text-3xl font-bold mb-4 tracking-tight">
              Desktop & Tablet Only
            </h2>
            <div className="w-12 h-1 bg-red-400/50 rounded-full mb-4"></div>
            <p className="text-slate-300 text-lg leading-relaxed">
              StatHospital has a complex interface designed specifically for
              larger screens.
              <br />
              <br />
              <span className="font-semibold text-white">
                Please log in on a desktop computer or a tablet device
              </span>{" "}
              for the best experience.
            </p>
          </>
        ) : (
          <>
            <div className="bg-indigo-500/20 p-4 rounded-full mb-6">
              <RotateCcw className="w-16 h-16 text-indigo-400 animate-[spin_3s_ease-in-out_infinite]" />
            </div>
            <h2 className="text-3xl font-bold mb-4 tracking-tight">
              Rotate Your Device
            </h2>
            <div className="w-12 h-1 bg-indigo-400/50 rounded-full mb-4"></div>
            <p className="text-slate-300 text-lg leading-relaxed">
              StatHospital requires landscape orientation to display all vital
              schedule and applicant information clearly.
              <br />
              <br />
              <span className="font-semibold text-white">
                Please rotate your tablet sideways to continue.
              </span>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileBlocker;
